// extracted by mini-css-extract-plugin
export default {"container":"_9CIwy","date":"ye5Jl","location":"_0gkoL","separator":"D3uAr"};